import TreeChart from "vue-binary-tree";

import SwapLeg from "@/components/SwapLeg";

export default {
  name: "binaryTree",
  components: {
    TreeChart,
    SwapLeg
  },
  data() {
    return {
      loading: false,
      serverTree: {},
      treeData: this.initTreeData(),
      currentPoint: {},
      currentUser: {},
      searchString: "",
    };
  },
  created() {
    this.getData();
    this.currentUser = this.$store.getters.currentUser;
  },
  methods: {
    clickNode(node) {
      this.getData(node.uuid);
    },
    getData(uuid) {
      this.loading = true;
      this.treeData = this.initTreeData();
      let url = "/api/v1/client/trees/1";
      let search = uuid === "search" ? "&username=" + this.searchString : "";

      if (uuid) url = "/api/v1/client/trees/1?uuid=" + uuid + search;
      this.$http({
        url: url,
        method: "get",
        headers: {
          "content-type": "application/json",
          Authorization: this.$store.getters.authToken,
        },
      })
        .then((response) => {
          this.loading = false;
          this.serverTree = this.updateTree(response.data);
        })
        .catch((error) => {
          this.loading = false;
          this.$toasted.show(error.response.data.error, {
            position: "top-right",
            duration: 5000,
            type: "error",
            closeOnSwipe: true,
          });
          this.getData();
        });
    },
    updateTree(data) {
      this.currentPoint = data.point;
      this.treeData.name = data.name;
      this.treeData.image_url = data.image_url;
      this.treeData.parent_binary_uuid = data.parent_binary_uuid;
      this.treeData.uuid = data.uuid;
      this.treeData.tooltip_placement = "right";
      this.treeData.tooltip_content =
        "<div class='text-left p-2'><p><br/><em>Sponsor: </em><b class='ml-3'><u>" +
        data.sponsor_username +
        "</u></b><br/><em>Left Points: </em><b class='ml-3'>" +
        data.point.left_points +
        "</b><br/><em>Right Points: </em><b class='ml-3'> " +
        data.point.right_points +
        "</b><br/><em>Left Total Points: </em><b class='ml-3'><u>" +
        data.point.left_total_points +
        "</u></b><br/><em>Right Total Points: </em><b class='ml-3'><u>" +
        data.point.right_total_points +
        "</u></b></p></div>";
      this.treeData.tooltip_html = true;
      // 1st level
      (data.children.length === 1 &&
        ((data.children[0].left_son &&
          this.propagateLeftNode(this.treeData, data)) ||
          (!data.children[0].left_son &&
            this.propagateRightNode(this.treeData, data)))) ||
        (data.children.length === 2 &&
          this.propagateTwoNodes(this.treeData, data));

      // 2nd level
      if (data.children[0].left_son) {
        // Left
        data.children.length === 2 &&
          ((data.children[0].children.length === 1 &&
            ((data.children[0].children[0].left_son &&
              this.propagateLeftNode(
                this.treeData.children[0],
                data.children[0]
              )) ||
              (!data.children[0].children[0].left_son &&
                this.propagateRightNode(
                  this.treeData.children[0],
                  data.children[0]
                )))) ||
            (data.children[0].children.length === 2 &&
              this.propagateTwoNodes(
                this.treeData.children[0],
                data.children[0]
              )));
        data.children.length === 1 &&
          ((data.children[0].children.length === 1 &&
            ((data.children[0].children[0].left_son &&
              this.propagateLeftNode(
                this.treeData.children[0],
                data.children[0]
              )) ||
              (!data.children[0].children[0].left_son &&
                this.propagateRightNode(
                  this.treeData.children[0],
                  data.children[0]
                )))) ||
            (data.children[0].children.length === 2 &&
              data.children[0].left_son &&
              this.propagateTwoNodes(
                this.treeData.children[0],
                data.children[0]
              )));
      }

      // Right
      data.children.length === 2 &&
        ((data.children[1].children.length === 1 &&
          ((data.children[1].children[0].left_son &&
            this.propagateLeftNode(
              this.treeData.children[1],
              data.children[1]
            )) ||
            (!data.children[1].children[0].left_son &&
              this.propagateRightNode(
                this.treeData.children[1],
                data.children[1]
              )))) ||
          (data.children[1].children.length === 2 &&
            this.propagateTwoNodes(
              this.treeData.children[1],
              data.children[1]
            )));
      data.children.length === 1 &&
        data.children[0].left_son &&
        ((data.children[0].children.length === 1 &&
          ((data.children[0].children[0].left_son &&
            this.propagateLeftNode(
              this.treeData.children[0],
              data.children[0]
            )) ||
            (!data.children[0].children[0].left_son &&
              this.propagateRightNode(
                this.treeData.children[0],
                data.children[0]
              )))) ||
          (data.children[0].children.length === 2 &&
            !data.children[0].left_son &&
            this.propagateTwoNodes(
              this.treeData.children[1],
              data.children[0]
            )));
      data.children.length === 1 &&
        !data.children[0].left_son &&
        ((data.children[0].children.length === 1 &&
          ((data.children[0].children[0].left_son &&
            this.propagateLeftNode(
              this.treeData.children[1],
              data.children[0]
            )) ||
            (!data.children[0].children[0].left_son &&
              this.propagateRightNode(
                this.treeData.children[1],
                data.children[0]
              )))) ||
          (data.children[0].children.length === 2 &&
            !data.children[0].left_son &&
            this.propagateTwoNodes(
              this.treeData.children[1],
              data.children[0]
            )));

      // 3th level
      if (data.children[0].left_son) {
        // Left 0
        if (data.children[0].children[0]) {
          data.children[0].children[0].children.length === 1 &&
            data.children[0].children[0].left_son &&
            data.children[0].children[0].children[0].left_son &&
            this.propagateLeftNode(
              this.treeData.children[0].children[0],
              data.children[0].children[0]
            );
          data.children[0].children[0].children.length === 1 &&
            data.children[0].children[0].left_son &&
            !data.children[0].children[0].children[0].left_son &&
            this.propagateRightNode(
              this.treeData.children[0].children[0],
              data.children[0].children[0]
            );
          data.children[0].children[0].children.length === 2 &&
            data.children[0].children[0].left_son &&
            this.propagateTwoNodes(
              this.treeData.children[0].children[0],
              data.children[0].children[0]
            );

          // Right 0
          data.children[0].children[0].children.length === 1 &&
            !data.children[0].children[0].left_son &&
            data.children[0].children[0].children[0].left_son &&
            this.propagateLeftNode(
              this.treeData.children[0].children[1],
              data.children[0].children[0]
            );
          data.children[0].children[0].children.length === 1 &&
            !data.children[0].children[0].left_son &&
            !data.children[0].children[0].children[0].left_son &&
            this.propagateRightNode(
              this.treeData.children[0].children[1],
              data.children[0].children[0]
            );
          data.children[0].children[0].children.length === 2 &&
            !data.children[0].children[0].left_son &&
            this.propagateTwoNodes(
              this.treeData.children[0].children[1],
              data.children[0].children[0]
            );
        }
        if (data.children[0].children[1]) {
          data.children[0].children[1].children.length === 1 &&
            data.children[0].children[1].children[0].left_son &&
            this.propagateLeftNode(
              this.treeData.children[0].children[1],
              data.children[0].children[1]
            );

          data.children[0].children[1].children.length === 1 &&
            !data.children[0].children[1].children[0].left_son &&
            this.propagateRightNode(
              this.treeData.children[0].children[1],
              data.children[0].children[1]
            );

          data.children[0].children[1].children.length === 2 &&
            this.propagateTwoNodes(
              this.treeData.children[0].children[1],
              data.children[0].children[1]
            );
        }
      }

      if (!data.children[0].left_son || data.children.length === 2) {
        let side = data.children[1] || data.children[0];
        // Left 1

        side.children[0].children.length === 1 &&
          side.children[0].left_son &&
          side.children[0].children[0].left_son &&
          this.propagateLeftNode(
            this.treeData.children[1].children[0],
            side.children[0]
          );
        side.children[0].children.length === 1 &&
          side.children[0].left_son &&
          !side.children[0].children[0].left_son &&
          this.propagateRightNode(
            this.treeData.children[1].children[0],
            side.children[0]
          );
        side.children[0].children.length === 2 &&
          side.children[0].left_son &&
          this.propagateTwoNodes(
            this.treeData.children[1].children[0],
            side.children[0]
          );

        // Right 1
        side.children[0].children.length === 1 &&
          !side.children[0].left_son &&
          side.children[0].children[0].left_son &&
          this.propagateLeftNode(
            this.treeData.children[1].children[1],
            side.children[0]
          );
        side.children[0].children.length === 1 &&
          !side.children[0].left_son &&
          !side.children[0].children[0].left_son &&
          this.propagateRightNode(
            this.treeData.children[1].children[1],
            side.children[0]
          );
        side.children[0].children.length === 2 &&
          !side.children[0].left_son &&
          this.propagateTwoNodes(
            this.treeData.children[1].children[1],
            side.children[0]
          );
        if (side.children[1]) {
          side.children[1].children.length === 1 &&
            side.children[1].children[0].left_son &&
            this.propagateLeftNode(
              this.treeData.children[1].children[1],
              side.children[1]
            );
          side.children[1].children.length === 1 &&
            !side.children[1].children[0].left_son &&
            this.propagateRightNode(
              this.treeData.children[1].children[1],
              side.children[1]
            );
          side.children[1].children.length === 2 &&
            this.propagateTwoNodes(
              this.treeData.children[1].children[1],
              side.children[1]
            );
        }
      }
    },
    propagateTwoNodes(object, data) {
      object.children[0].uuid = data.children[0].uuid;
      object.children[0].name = data.children[0].name;
      object.children[0].image_url = data.children[0].image_url;
      object.children[0].left_son = data.children[0].left_son;
      object.children[0].tooltip_placement = "left";
      object.children[0].tooltip_content =
        "<div class='text-left p-2'><p><em>Sponsor: </em><b class='ml-3'><u>" +
        data.children[0].sponsor_username +
        "</u></b><br/><em>Left Points: </em><b class='ml-3'>" +
        data.children[0].point.left_points +
        "</b><br/><em>Right Points: </em><b class='ml-3'> " +
        data.children[0].point.right_points +
        "</b></p></div>";
      object.children[0].tooltip_html = true;

      // right node
      object.children[1].uuid = data.children[1].uuid;
      object.children[1].name = data.children[1].name;
      object.children[1].image_url = data.children[1].image_url;
      object.children[1].left_son = data.children[1].left_son;
      object.children[1].tooltip_placement = "right";
      object.children[1].tooltip_content =
        "<div class='text-left p-2'><p><em>Sponsor: </em><b class='ml-3'><u>" +
        data.children[1].sponsor_username +
        "</u></b><br/><em>Left Points: </em><b class='ml-3'>" +
        data.children[1].point.left_points +
        "</b><br/><em>Right Points: </em><b class='ml-3'> " +
        data.children[1].point.right_points +
        "</b></p></div>";
      object.children[1].tooltip_html = true;
    },
    propagateLeftNode(object, data) {
      object.children[0].uuid = data.children[0].uuid;
      object.children[0].name = data.children[0].name;
      object.children[0].image_url = data.children[0].image_url;
      object.children[0].left_son = data.children[0].left_son;
      object.children[0].tooltip_placement = "left";
      object.children[0].tooltip_content =
        "<div class='text-left p-2'><p><em>Sponsor: </em><b class='ml-3'><u>" +
        data.children[0].sponsor_username +
        "</u></b><br/><em>Left Points: </em><b class='ml-3'>" +
        data.children[0].point.left_points +
        "</b><br/><em>Right Points: </em><b class='ml-3'> " +
        data.children[0].point.right_points +
        "</b></p></div>";
      object.children[0].tooltip_html = true;
      return true;
    },
    propagateRightNode(object, data) {
      object.children[1].uuid = data.children[0].uuid;
      object.children[1].name = data.children[0].name;
      object.children[1].image_url = data.children[0].image_url;
      object.children[1].left_son = data.children[0].left_son;
      object.children[1].tooltip_placement = "right";
      object.children[1].tooltip_content =
        "<div class='text-left p-2'><p><em>Sponsor: </em><b class='ml-3'><u>" +
        data.children[0].sponsor_username +
        "</u></b><br/><em>Left Points: </em><b class='ml-3'>" +
        data.children[0].point.left_points +
        "</b><br/><em>Right Points: </em><b class='ml-3'> " +
        data.children[0].point.right_points +
        "</b></p></div>";
      object.children[1].tooltip_html = true;
      return true;
    },
    initTreeData() {
      return {
        name: "user",
        image_url: "/images/user.svg",
        parent_binary_uuid: null,
        uuid: null,
        children: [
          {
            name: "user",
            image_url: "/images/user.svg",
            children: [
              {
                name: "user",
                image_url: "/images/user.svg",
                children: [
                  {
                    name: "user",
                    image_url: "/images/user.svg",
                  },
                  {
                    name: "user",
                    image_url: "/images/user.svg",
                  },
                ],
              },
              {
                name: "user",
                image_url: "/images/user.svg",
                children: [
                  {
                    name: "user",
                    image_url: "/images/user.svg",
                  },
                  {
                    name: "user",
                    image_url: "/images/user.svg",
                  },
                ],
              },
            ],
          },
          {
            name: "user",
            image_url: "/images/user.svg",
            children: [
              {
                name: "user",
                image_url: "/images/user.svg",
                children: [
                  {
                    name: "user",
                    image_url: "/images/user.svg",
                  },
                  {
                    name: "user",
                    image_url: "/images/user.svg",
                  },
                ],
              },
              {
                name: "user",
                image_url: "/images/user.svg",
                children: [
                  {
                    name: "user",
                    image_url: "/images/user.svg",
                  },
                  {
                    name: "user",
                    image_url: "/images/user.svg",
                  },
                ],
              },
            ],
          },
        ],
      };
    },
    firstNode() {
      this.getData(this.$store.getters.currentUser.uuid);
    },
    prevNode() {
      this.getData(this.treeData.parent_binary_uuid);
    },
  },
};
